<template>
  <div
    class="flex items-center justify-center flex-shrink-0 rounded-xl bg-primary-100 text-primary"
    style="width:44px; height:44px;"
  >
    <svg v-if="icon === 'circle'" width="22" height="22" viewBox="0 0 22 22">
      <circle
        cx="11"
        cy="11"
        r="7"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      />
      <circle cx="11" cy="11" r="1.6" fill="currentColor" />
    </svg>
    <svg
      v-else-if="icon === 'chart'"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <rect x="3" y="12" width="4" height="7" fill="currentColor" />
      <rect x="9" y="7" width="4" height="12" fill="currentColor" />
      <rect x="15" y="3" width="4" height="16" fill="currentColor" />
    </svg>
    <svg v-else-if="icon === 'card'" width="22" height="22" viewBox="0 0 22 22">
      <rect
        x="2"
        y="5"
        width="18"
        height="12"
        rx="2"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      />
      <line
        x1="2"
        y1="9"
        x2="20"
        y2="9"
        stroke="currentColor"
        stroke-width="2"
      />
    </svg>
    <svg v-else-if="icon === 'doc'" width="22" height="22" viewBox="0 0 22 22">
      <rect
        x="4"
        y="2"
        width="14"
        height="18"
        rx="1.5"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      />
      <line
        x1="7.5"
        y1="8"
        x2="14.5"
        y2="8"
        stroke="currentColor"
        stroke-width="1.6"
      />
      <line
        x1="7.5"
        y1="13"
        x2="14.5"
        y2="13"
        stroke="currentColor"
        stroke-width="1.6"
      />
    </svg>
    <svg
      v-else-if="icon === 'trend'"
      width="22"
      height="22"
      viewBox="0 0 22 22"
    >
      <polyline
        points="2,18 8,11 12,14 20,4"
        fill="none"
        stroke="currentColor"
        stroke-width="2.2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
    <svg v-else width="22" height="22" viewBox="0 0 22 22">
      <circle
        cx="11"
        cy="11"
        r="8.5"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
      />
      <polyline
        points="7,11.5 10,14.5 15,8"
        fill="none"
        stroke="currentColor"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: "TopicIcon",
  props: {
    icon: {
      type: String,
      default: "circle"
    }
  }
};
</script>
